module.exports = __webpack_public_path__ + "components/outside-promo-page/static/logo-7a54f1954ed227d20bf9e156f4eb8b5f.svg";